export const EIGHT_PIXELS_PER_UNIT = 8;
export const applyConstellationScalingFactor = (spacingInPixels: number) => spacingInPixels / EIGHT_PIXELS_PER_UNIT;
